export default __webpack_public_path__ + "static/210521_妲絲刷關活動熱更預告_tc-f4f58253e9bdc3e0952581c785b1a781.webp";